// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"f7f8eae4","561":"18e965a6","731":"9cc458f8"}[chunkId] + ".chunk.js";
};